import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';
import { Roles } from '../models/enums';


@Injectable({ providedIn: 'root'})
export class NoteEndpoint extends EndpointFactory {

  private readonly _noteUrl: string = '/api/note';
  private readonly _noteByParentIdUrl: string = '/api/note/parent';

  get notesUrl() { return this.configurations.baseUrl + this._noteUrl; }
  get notesByParentIdUrl() { return this.configurations.baseUrl + this._noteByParentIdUrl; }

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);
  }

  getNotesByAbstractProtocolIdEndpoint<T>(abstractId: number, protocolId: number, activeRole: Roles): Observable<T> {
    const endpointUrl = abstractId ? `${this.notesUrl}/${abstractId}/${protocolId}` : this.notesUrl;
    const options = {...this.getRequestHeaders()};
    if (activeRole) { options['params'] = {activeRole}; }

    return this.http.get<T>(endpointUrl, options);
  }

  getNotesByParentIdEndpoint<T>(noteId: number): Observable<T> {
    const endpointUrl = noteId ? `${this.notesByParentIdUrl}/${noteId}` : this.notesByParentIdUrl;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders());
  }

  addNoteEndpoint<T>(note: any): Observable<T> {
    return this.http.post<T>(this.notesUrl, JSON.stringify(note), this.getRequestHeaders());
  }
}
